'use client'

import React from 'react'

// vnw components
import { Hooks, Notifications } from '@/libs/react-components'
import { ELanguage } from '@/common'
import { TUser } from './type'

const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY ?? '',
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN ?? '',
    databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL ?? '',
    refreshJWTUrl: `${process.env.NEXT_PUBLIC_VNW_JOBSEEKER_URL}/my-career-center/employer-message/?action=renewFirebaseJWT`
}

interface IProps {
    langCode: ELanguage
    user: TUser
}

function NotificationComponent({ langCode, user }: IProps) {
    const isShow = Hooks.useInitNotification()

    const notificationProps = {
        langCode: langCode,
        firebaseConfig: firebaseConfig,
        jobSeekerUrl: process.env.NEXT_PUBLIC_VNW_JOBSEEKER_URL ?? '',
        baseMsUrl: process.env.NEXT_PUBLIC_MICROSERVICE_DOMAIN ?? '',
        user: user as Omit<TUser, 'jobLevelId'> & { jobLevelId: number[] }
    }

    return isShow ? <Notifications config={notificationProps} langCode={langCode} user={user} /> : null
}

function arePropsEqual(oldProps: IProps, newProps: IProps) {
    return oldProps.user?.userId === newProps.user?.userId
}

export default React.memo(NotificationComponent, arePropsEqual)
